import * as ProductHelper from "helpers/ProductHelper";

export const handleRequest = async (path, method) => {
  switch (path) {
    case "/items":
    case "/products":
      return await handleProducts(method);
    default:
      return { message: "API not found", status: 404 };
  }
};

function handleProducts(method) {
  if (method === "GET") {
    return getProducts();
  }
  return { message: "Method not allowed", status: 405 };
}

async function getProducts() {
  const availableProducts = await ProductHelper.getActiveProductsForCaptain();
  return {
    status: 200,
    message: "item list",
    data: availableProducts,
  };
}
